<template>
  <div class="downgrade">
    <div class="downgrade-list">
        <div class="downgrade-select-file">
          <el-upload
            ref="downgradeUpload"
            class="downgrade-uploader"
            action="#"
            :multiple="false"
            :http-request="preUpload"
            :on-change="fileChange"
            accept=".rfa"
            :auto-upload="false"
            :file-list="fileList"
            :on-remove="handleRemove"
            :limit="2"
            >
              <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
          </el-upload>
          <div class="downgrade-select-list" v-if="currentVersion">
            <div class="degrandable-version" v-if="downgradeVersions && downgradeVersions.length > 0">
              <span>指定降级版本: </span>
              <el-radio-group v-model="downgradeVersion">
                  <el-radio :label="version" v-for="version in downgradeVersions" :key="version">{{version}}</el-radio>
              </el-radio-group>
              <div class="tip">提示：由于版本兼容问题，降级过程中不保留形体约束关系，可能存在信息丢失。</div>
              <el-button type="primary" @click="handleOk">一键降级</el-button>
            </div>
            <div v-else-if="this.currentVersion <= 2016" class="warning-tip">提示：当前版本{{ currentVersion }} 无可降级版本！</div>
            <div v-else-if="this.currentVersion >= 2023" class="warning-tip">提示：当前版本{{ currentVersion }} 版本过高，暂不支持！</div>
          </div>
        </div>
        <div class="downgrade-list-table">
          <div class="btn-right">
            <span>共 {{ totalCount }} 个内容</span>
            <el-button
              type="text"
              icon="el-icon-refresh-right"
              title="刷新"
              class="refresh-btn"
              @click="refreshList"
            />
          </div>
          <gjw-list-page-layout>
              <template #tableBox>
                  <gjw-table
                    ref="listTable"
                    v-loading="tableLoading"
                    :columns="tableColumns"
                    :request-fn="$api.downgrade.getDowngrades"
                    @list-change="listChange"
                    :has-page="true"
                    >
                    <template #statusSlot="{ row }">
                      <span class="table-name">
                        <span v-if="row.status === 'processing'" class="processing">处理中</span>
                        <span v-else-if="row.status === 'success'" class="success">处理成功</span>
                        <span v-else class="failure">处理失败</span>
                      </span>
                    </template>
                    <template #operationSlot="{ row }">
                      <span class="table-name">
                        <el-button type="text" @click="onDownload(row)" :disabled="row.status === 'processing'">下载</el-button>
                      </span>
                    </template>
                  </gjw-table>
              </template>
          </gjw-list-page-layout>
        </div>
    </div>
  </div>
</template>

<script>
import Upload from '@/core/upload'
import { RegSymbol } from '@/core/RegExp'
import Queue from '@/core/queue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      upQueue: new Queue(5, this.uploading, this.uploadWait),
      downgradeVersion: null,
      tableLoading: false,
      tableColumns: [
        {
          label: '族名称',
          prop: 'name',
          minWidth: '160px',
        },
        {
          label: '原版本',
          prop: 'version',
          minWidth: '100px',
        },
        {
          label: '降级目标版本',
          prop: 'targetVersion',
          minWidth: '100px',
        },
        {
          type: 'slot',
          slotName: 'statusSlot',
          label: '状态',
          prop: 'status',
          minWidth: '80px'
        },
        {
          type: 'slot',
          slotName: 'operationSlot',
          label: '操作',
          minWidth: '60px'
        }
      ],
      totalCount: 0,
      fileList: [],
      uploadList: [],
      selectFile: [],
      currentVersion: null,
      degrandableVersions: [2016, 2017, 2018, 2019, 2020, 2021]
    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform'
    }),
    downgradeVersions() {
      if (!this.currentVersion || this.currentVersion >= 2023 || this.currentVersion <= 2016) {
        return null
      }
      return this.degrandableVersions.filter((f) => f < this.currentVersion)
    }
  },
  created() {
    this.$tracks({ event: 'visitDowngrade' })
  },
  methods: {
    listChange(tableList, dataTotal) {
      this.totalCount = dataTotal
    },
    refreshList() {
      this.$refs.listTable && this.$refs.listTable.refresh()
    },
    onDownload(row) {
      const downloadThis = this
      this.$api.downgrade.getDownloadUrl(row.id).then((res) => {
        if (downloadThis.platform === 'web') {
          window.open(res, '_blank')
        } else {
          this.$desktopClient.NavigateToBrowser(res)
        }
        this.$tracks({
          event: 'downgradeDownload',
          params: {
            g_c_file_id: row.id,
            g_c_file_name: row.name,
            g_c_file_version: row.targetVersion
          }
        })
      }).catch((err) => {
        if (err.code === 'illegal.argument') {
          this.$message.error('族不存在，请重新下载。')
        } else if (err.code === 'downgrade.failed') {
          this.$message.error('降级失败，请重新上传。')
        } else if (err.code === 'downgrade.processing') {
          this.$message.error('降级处理中，请稍后。')
        }
      })
    },
    /**
         * 准备上传文件：
         * 如果上传中的文件数量uploadingCount < 最大可上传的数量maxUploadingCount，则调用uploading（）直接上传
         * 否则，加入uploadQueue队列，等待上传*/
    async preUpload(payload) {
      const payloadFile = payload.file ? payload.file : payload
      const file = this.selectFile.find((f) => f.uid === payloadFile.uid && f.uploadStatus !== 'fail')
      if (file) {
        this.upQueue.preDo(file)
      }
    },
    handleRemove(file, fileList) {
      this.fileTable = []
      this.selectFile = []
      this.uploadList = []
      this.renewalList = []
      this.currentVersion = null
      this.downgradeVersion = null
    },
    async fileChange(file, fileList) {
      this.fileList = [file]
      this.fileTable = []
      this.selectFile = []
      this.uploadList = []
      this.renewalList = []
      if (file.status === 'ready') {
        if (!this.checkFile(file)) {
          const index = fileList.findIndex((x) => { return x.uid === file.uid })
          fileList.splice(index, 1)
          return
        }
        await this.getSpecialMethod().parseFile(file)
        file.md5 = await this.$getMd5(file.raw)
        this.fileListChange(file)
      }
    },
    // 检查文件
    checkFile(file) {
      const size = file.size
      if (!size) {
        this.$message.error(`文件内容为空，已自动删除不符合的文件`)
        return false
      }
      const isNameInvalid = RegSymbol.test(file.name)
      if (isNameInvalid) {
        this.$message.error(`文件名中含禁用字符，已自动删除不合规文件`)
        return false
      }
      return true
    },
    // 上传文件列表变化后
    async fileListChange(file) {
      if (this.fileTable.find((it) => { return it.name === file.name })) {
        this.$message.error('文件名称重复，已自动删除重名文件')
        return
      }
      const valid = this.validFileInfo(file)
      if (!valid) {
        this.$message.error(file.validatedText)
      } else {
        this.handleSelectionChange([file])
      }
      this.currentVersion = file.softwareVersion
    },
    // 检验文件
    validFileInfo(file) {
      return this.getSpecialMethod().valid(file)
    },
    // 更新文件状态、进度条等
    updateFile(file, newOpts) {
      const targetArr = this.uploadList
      targetArr.forEach((item, index) => {
        if (item.uid === file.uid) {
          item = { ...item, ...newOpts }
          targetArr.splice(index, 1, item)
        }
      })
    },
    // 勾选上传的文件后
    handleSelectionChange(val) {
      this.selectFile = val
    },
    /**
         * 进度条更新*/
    processCb(file, percentage) {
      this.updateFile(file, { uploadProgress: percentage })
    },
    /** * 文件开始上传 */
    async uploading(file) {
      try {
        const that = this
        that.updateFile(file, { uploadStatus: 'uploading' })
        const fileInfo = await Upload.uploadFile.call(that, file, false, that.processCb)
        if (fileInfo) {
          this.success(fileInfo)
        } else {
          this.error(file)
        }
      } catch (err) {
        this.error(file)
      }
    },
    handleOk() {
      this.uploadStart()
    },
    // 开始上传流程
    async uploadStart() {
      this.getSpecialMethod().uploadStart()
    },
    // 上传成功
    uploadSuccess(file) {
      this.updateFile(file, { uploadProgress: 100 })
      if (file.storeId) {
        this.startDowngrade(file)
        this.$refs.downgradeUpload && this.$refs.downgradeUpload.clearFiles()
      } else {
        this.uploadError(file)
      }
    },
    // 发起降级请求
    startDowngrade(file) {
      this.$api.downgrade.startDowngrade({
        storeId: file.storeId,
        name: file.name,
        version: file.softwareVersion,
        targetVersion: this.downgradeVersion
      }).then((res) => {
        if (res && res.id) {
          this.$message.info('开始降级，请稍后...')
          this.handleRemove()
          this.$tracks({
            event: 'downgrade',
            params: {
              g_c_file_id: res.id,
              g_c_file_name: file.name,
              g_c_file_version_down: this.downgradeVersion
            }
          })
          this.refreshList()
        }
      })
    },
    /**
     * 等待上传的文件push到上传队列中*/
    uploadWait(file) {
      this.updateFile(file, { uploadStatus: 'waiting' })
    },
    // 不同类型资源验证、解析、开始上传
    getSpecialMethod() {
      return {
        valid: (file) => {
          if (file.name.includes('\\') || file.name.includes('/') || file.name.includes(':') ||
                  file.name.includes('*') || file.name.includes('<') || file.name.includes('>') ||
                  file.name.includes('|') || file.name.includes('?')) {
            file.validatedText = '校验失败'
            return false
          }
          if (parseInt(file.appVersion) <= 2016) {
            file.validatedText = '无可降级版本'
            return false
          }
          if (parseInt(file.appVersion) >= 2023) {
            file.validatedText = '版本过高，暂不支持'
            return false
          }
          if (!file.appName && file.appName === '') {
            file.validatedText = '软件未能解析'
            return false
          }
          if (!file.appVersion && file.appVersion === '') {
            file.validatedText = '版本未能解析'
            return false
          }
          return true
        },
        uploadStart: async() => {
          this.loading = true
          this.selectFile.forEach((file) => {
            file.uploadProgress = 0
            file.uploadStatus = 'waiting'
            file.softwareCode = this.softwareCode
            this.uploadList.push(file)
          })
          await this.$refs.downgradeUpload.submit()
          this.loading = false
          this.modalVisible = false
          this.isFold = false
          this.activeTab = this.operate
          this.tagIds = []
          this.tagNames = ''
        },
        parseFile: async(file) => {
          const [versionObj] = await this.fileExtract(file)
          if (versionObj) {
            file.appName = versionObj.ProjectAppName ? versionObj.ProjectAppName : ''
            file.softwareCode = versionObj.ProjectAppName ? versionObj.ProjectAppName : ''
            file.appVersion = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
            file.softwareVersionName = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
            file.softwareVersion = versionObj.ProjectAppVersion ? versionObj.ProjectAppVersion : ''
          } else {
            file.appName = '-'
          }
          file.spaceCategoryId = this.spaceCategoryId
          file.md5 = await this.$getMd5(file.raw)
        }
      }
    },
    async fileExtract(file) {
      const fileSuffixs = file.name.split('.').slice(-1)
      if ('rfa'.includes(fileSuffixs) || 'rte'.includes(fileSuffixs) || 'rvt'.includes(fileSuffixs)) {
        return await Promise.all([this.$getRevitJson(file.raw, fileSuffixs[0])])
      } else if ('dwg'.includes(fileSuffixs) || 'dxf'.includes(fileSuffixs)) {
        return await Promise.all([this.$getCADJson(file.raw, fileSuffixs[0])])
      }
      return await Promise.all([])
    },
    // 上传成功
    success(file) {
      this.uploadSuccess(file)
      this.upQueue.nextDo()
    },
    // 上传失败
    error(file) {
      this.uploadError(file)
      this.upQueue.nextDo()
    },
  }
}

</script>

<style lang="less" scoped>
.downgrade {
  display: flex;
  justify-content: center;
  height: 100%;
}
.downgrade-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 588px;
  min-height: 500px;
  padding: 20px;
}
.downgrade-select-list {
  margin-top: 10px;
  .degrandable-version {
    span {
      margin-right: 10px;
    }
    .tip {
      margin-top: 10px;
      margin-bottom: 10px;
      color: #ccc;
    }
  }
}
.downgrade-select-file {
  border-bottom: solid 1px #e6e6e6;
  padding-bottom: 10px;
}
.warning-tip {
  margin-top: 10px;
  color: #ff0000;
  font-weight: 600;
}
.btn-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.gjw-table {
  height: unset;
}
/deep/.right-part {
  padding: unset;
}
/deep/.gjw-table .el-table .el-table__body-wrapper {
  height: 190px !important;
}
/deep/.el-divider--horizontal {
  margin: 10px 0 !important;
}
.processing{
  color: @theme-color;
}
.success{
  color: @success-color;
}
.failure{
  color: @error-color;
}
</style>
